import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { RouteService } from '@services/route.service';
import { ProductService } from '@services/product.service';
import { GlobalService } from '@services/global.service';
import { Product, Categ, SCateg, Gamme, Marque, Tag, Banner } from '@models/product';
import { ProductFilter } from '@models/filter';
import { environment } from '@environments/environment';
import { switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'gob-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.css']
})
export class ProductListComponent implements OnInit {
  loading: boolean=false;
  error: string;
  msg: string;
  isFilter: boolean = false;
  products: Product[]=[];
  categs: Categ[]=[];
  scategs: SCateg[]=[];
  gammes: Gamme[]=[];
  marques: Marque[]=[];
  banners: Banner[]=[];
  tags: Tag[]=[];
  size: number=50;
  max: number=0;
  page: number=0;
  filter: ProductFilter;

  constructor(
    public route: RouteService,
    private gServ: GlobalService,
    private productServ: ProductService
  ) {
    this.loading=true;
    this.filter=new ProductFilter();

    forkJoin({
      classes: this.gServ.getClassification(),
    })
    .pipe(
      tap(result => {
      this.categs = result.classes.categs;
      this.scategs = result.classes.scategs;
      this.gammes = result.classes.gammes;
      this.marques = result.classes.marques;
      this.tags = result.classes.tags;
      this.banners = result.classes.banners;
    }),
      switchMap(() => this.search(false)),
    )
    .subscribe({
      next: () => {
        this.page = 0;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  ngOnInit(): void { }

  /**
   * Appelé par le bouton "Voir plus" du composant pagination
   * @param page La page à afficher
   */
  next(page: number, filter: ProductFilter){
    this.page = page;
    this.loading = true;
    this.search(true, filter).subscribe(() => this.loading = false);
  }

  /**
   * Recherche des produits avec un filtre
   * @param append Si true, on ajoute les nouveaux produits à la liste existante. Sinon, on remplace.
   * @param filter Le filtre à appliquer
   * @returns Un observable qui émet les produits correspondants au filtre
   */
  search(append: boolean = false, filter?: ProductFilter){
    let search: ProductFilter = ((filter) ? filter : this.filter);

    return this.productServ.list(search, this.page * this.size, this.size)
      .pipe(
        tap((newProducts: any[]) => {
          if (append) {
            // AJOUT : On concatène les nouveaux produits aux anciens
            this.products = [...this.products, ...newProducts];
          } else {
            // REMPLACEMENT : Pour le premier chargement ou un filtre
            this.products = newProducts;
          }

          // Gestion du bouton voir plus : s'affiche s'il reste potentiellement des pages
          if (newProducts.length === this.size) {
            this.max = this.page + 2;
          } else {
            this.max = this.page; // On cache le bouton
          }
          this.filter=filter;
        })
      )
  }

  filterProduct(filter: ProductFilter) {
    this.isFilter = true;
    this.max = 0;
    this.page = 0;
    this.products = []; 
    this.next(0, { ...filter, ...this.filter });
  }

  rm(ident: string){
    if(confirm('Etes-vous sûr de vouloir supprimer ce produit ?')){
      this.loading=true;
      this.productServ.rmProduct(ident).subscribe({
        next: () => {
          this.loading=false;
          this.next(this.page, this.filter);
        },
        error: e => {
          this.error=e;
          this.loading=false;
        }
      });
    }
  }

  getCateg(product: Product){
    return this.categs.find(e => e.ident==product.categ);
  }

  getSCateg(product: Product){
    return this.scategs.find(e => e.ident==product.scateg);
  }

  getGamme(product: Product){
    return this.gammes.find(e => e.ident==product.gamme);
  }

  getMarque(product: Product){
    return this.marques.find(e => e.ident==product.marque);
  }

  getImage(product: Product){

    if (product.cover)
      return `${environment.imgUrl}/product/${product.cover}`;

    if (product.mainImage === null)
      return `assets/img/logo/logo.png`;

    return `${environment.imgUrl}/product/${product.mainImage.name}`;

  }

}
